export const userConstants = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SIGNUP:"SIGNUP",
  GET_LOGGED_IN_USER:"GET_LOGGED_IN_USER",
  UPDATE_ADDRESS: "UPDATE_ADDRESS",
  DELETE_ADDRESS:"DELETE_ADDRESS",
  CREATE_NEW_ADDRESS:"CREATE_NEW_ADDRESS",
  CREATE_NEW_ORDER:"CREATE_NEW_ORDER",
  GET_ALL_ORDERS:"GET_ALL_ORDERS",
};

export const productsDispatchConstants = {
  UPDATE_PRODUCTS_LIST: "UPDATE_PRODUCTS_LIST",
  SET_FILTERS_AND_SORTS: "SET_FILTERS_AND_SORTS",
  SET_CATEGORY: "SET_CATEGORY",
  RESET_FILTER: "RESET_FILTER",
};

export const cartWishlistDispatchConstants = {
  GET_CART_LIST: "GET_CART_LIST",
  ADD_ITEM_TO_CART: "ADD_ITEM_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  CHANGE_ITEM_QUANTITY: "CHANGE_ITEM_QUANTITY",
  CLEAR_CART: "CLEAR_CART",
  GET_WISHLIST: "GET_WISHLIST",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
  CLEAR_TOAST_MESSAGE: "CLEAR_TOAST_MESSAGE",
};

export const localStorageConstants = {
  USER_TOKEN: "userToken",
  USER_INFO: "userInfo",
};
